import { Badge, BadgeSizes, BadgeVariants } from '@carboledger/ui';
import { UNIT_TYPES } from '@/config/unitTypes.constants';
import { ALLOCATION_STATUS_TONE } from '@/config/statusTones';
import { InfoLabel } from '../components/InfoLabel';

// The read-only ALLOCATION DETAILS card at the top of the shipment wizards.
export const buildAllocationDetailFields = (t, allocation) => [
  { id: 'material', label: t('FIELD_MATERIAL_NAME'), value: allocation?.materialName },
  { id: 'facility', label: t('FIELD_FACILITY_NAME'), value: allocation?.facilityName },
  {
    id: 'terminal',
    label: <InfoLabel>{t('FIELD_TERMINAL')}</InfoLabel>,
    value: allocation?.terminal,
  },
  { id: 'soldTo', label: t('FIELD_SOLD_TO'), value: allocation?.sendTo },
  { id: 'shippingTo', label: t('FIELD_SHIPPING_TO'), value: allocation?.shippingTo },
  {
    id: 'status',
    label: t('FIELD_STATUS'),
    value: (
      <Badge
        variant={ALLOCATION_STATUS_TONE[allocation?.statusCode] ?? BadgeVariants.default}
        size={BadgeSizes.sm}
        withDot
      >
        {allocation?.status}
      </Badge>
    ),
  },
  {
    id: 'certifiedDeclaration',
    label: <InfoLabel>{t('ALLOCATIONS_COL_CERTIFIED_QUANTITY')}</InfoLabel>,
    value: allocation?.byUnit?.[UNIT_TYPES.declaration]?.certifiedQuantity ?? '-',
  },
  {
    id: 'certifiedWorking',
    label: <InfoLabel>{t('ALLOCATIONS_COL_CERTIFIED_QUANTITY')}</InfoLabel>,
    value: allocation?.byUnit?.[UNIT_TYPES.working]?.certifiedQuantity ?? '-',
  },
];
